// removed by extract-text-webpack-plugin
module.exports = {"foreground":"dh-dh-plast-quiz-foreground","app--is-android-app":"dh-dh-plast-quiz-app--is-android-app","foreground--centered":"dh-dh-plast-quiz-foreground--centered","foreground__inner":"dh-dh-plast-quiz-foreground__inner"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/Foreground/index.css
// module id = 60
// module chunks = 0